import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { openDialog } from '../../../base/dialog/actions';
import DialogRoomCascade from './DialogRoomCascade';
import { setOverflowMenuVisible } from '../../../toolbox/actions.web';
import { IconCascadeRoom } from '../../../base/icons/svg';
/**
 * React {@code Component} responsible for displaying a button in the overflow
 * menu of the toolbar, including an icon showing the currently selected
 * max receive quality.
 *
 * @augments Component
 */
class RoomCascadeButton extends AbstractButton {
    constructor() {
        // accessibilityLabel = 'toolbar.accessibilityLabel.callQuality';
        // label = 'videoStatus.performanceSettings';
        // tooltip = 'videoStatus.performanceSettings';
        // icon = IconPerformance;
        super(...arguments);
        this.accessibilityLabel = 'roomCascade.function';
        this.label = 'roomCascade.function';
        this.tooltip = 'roomCascade.function';
        this.icon = IconCascadeRoom;
    }
    /**
    * Handles clicking the button, and opens the video quality dialog.
    *
    * @private
    * @returns {void}
    */
    _handleClick() {
        const { dispatch } = this.props;
        sendAnalytics(createToolbarEvent('cascade'));
        dispatch(openDialog(DialogRoomCascade));
        dispatch(setOverflowMenuVisible(false));
    }
}
export default connect()(translate(RoomCascadeButton));
